// src/pages/Settings/tabs/AchievementsTab.js
import React from 'react';
import { useProfile } from '../../../context/ProfileContext';

const AchievementsTab = () => {
    const { userProfile } = useProfile();
    
    // Assuming your userProfile contains a 'streaks' or 'achievements' object
    const currentStreak = userProfile?.dailyStreak || 0;
    const highestStreak = userProfile?.highestStreak || 0;

    return (
        <div className="space-y-6 animate-in slide-in-from-bottom-4 duration-500">
            <header className="mb-6">
                <h2 className="text-xl font-black uppercase tracking-tight dark:text-white">Achievements</h2>
                <p className="text-sm text-slate-500">Your milestones and activity streaks.</p>
            </header>

            <div className="grid grid-cols-2 gap-4">
                <div className="p-6 bg-white dark:bg-slate-900 border dark:border-slate-800 rounded-3xl text-center shadow-sm">
                    <div className="text-3xl mb-2">🔥</div>
                    <div className="text-2xl font-black dark:text-white">{currentStreak}</div>
                    <div className="text-[10px] uppercase font-bold text-slate-400 tracking-widest">Current Streak</div>
                </div>

                <div className="p-6 bg-white dark:bg-slate-900 border dark:border-slate-800 rounded-3xl text-center shadow-sm">
                    <div className="text-3xl mb-2">🏆</div>
                    <div className="text-2xl font-black dark:text-white">{highestStreak}</div>
                    <div className="text-[10px] uppercase font-bold text-slate-400 tracking-widest">Best Ever</div>
                </div>
            </div>

            {/* Placeholder for future badges */}
            <div className="p-8 border-2 border-dashed border-slate-100 dark:border-slate-800 rounded-3xl text-center">
                <p className="text-xs text-slate-400 font-medium italic">
                    New achievement badges are being minted...
                </p>
            </div>
        </div>
    );
};

export default AchievementsTab;